import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "cmp__top-configurator-toolbar"
};
import { useConfiguratorStore } from '@/stores/configurator';
import { storeToRefs } from 'pinia';
import { useWindowSize } from '@vueuse/core';
export default {
  __name: 'PreviewToolbar',
  setup(__props) {
    const configuratorStore = useConfiguratorStore();
    const {
      mobileBreakpoint
    } = storeToRefs(configuratorStore);
    const {
      width: windowWidth
    } = useWindowSize();
    return (_ctx, _cache) => {
      return _unref(windowWidth) > _unref(mobileBreakpoint) ? (_openBlock(), _createElementBlock("div", _hoisted_1)) : _createCommentVNode("", true);
    };
  }
};